import React, { createElement, useCallback } from 'react';
import { NotFound } from '../../NotFound';
import { useClientTokenManager, useFeatureFlags, useRequiredAccountLevel } from '../../../context';
import { BlockedAccountLevelView } from '../../BlockedAccountLevelView';
import { LayoutRoute } from '../../LayoutRoute';
import { BlockSegmentsOnlyUsersFlag } from '../../../constants/featureFlagConstants';
export const Route = ({ component, path, requiredAccountLevels, routes, ...rest }) => {
    const { hasRequiredAccountLevel } = useRequiredAccountLevel(requiredAccountLevels);
    const { isSegmentsOnlyUser } = useClientTokenManager();
    const { getFeatureFlag } = useFeatureFlags();
    const blockSegmentsOnlyUsersEnabled = getFeatureFlag(BlockSegmentsOnlyUsersFlag);
    const renderRoute = useCallback((props) => {
        if (blockSegmentsOnlyUsersEnabled) {
            if (isSegmentsOnlyUser &&
                requiredAccountLevels &&
                !requiredAccountLevels.includes('segment')) {
                return React.createElement(NotFound, null);
            }
        }
        if (!hasRequiredAccountLevel && requiredAccountLevels) {
            return (React.createElement(BlockedAccountLevelView, { path: path, requiredAccountLevels: requiredAccountLevels, variant: "page" }));
        }
        return createElement(component, { ...props, routes, path });
    }, [
        blockSegmentsOnlyUsersEnabled,
        hasRequiredAccountLevel,
        requiredAccountLevels,
        component,
        routes,
        path,
        isSegmentsOnlyUser,
    ]);
    return React.createElement(LayoutRoute, { ...rest, path: path, render: renderRoute });
};
